module.exports = __webpack_public_path__ + "img/M5J19_BannerAnimation_FirstFrame_v4.3fb34335.png";